export default __webpack_public_path__ + "static/MikeFeeley-35cee098a7baa8ee32710cbccea46a1a.jpg";